export default "__VITE_ASSET__rNHY0fnd__"